<template>
  <div @click="switchClicked($event);" class="SingleSwitchGeneral lxn-cursor-pointer" :class="disabledClass">
    <div class="SingleSwitchGeneral-switch lxn-w100 lxn-h100 lxn-pos-rel" :class="switchClass">
      <div class="SingleSwitchGeneral-switchOval lxn-h100" :style="ovalStyle"></div>
      <div class="SingleSwitchGeneral-switchCircle lxn-pos-abs" :style="circleStyle"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SingleSwitchGeneral',
  props: {
    state: String,
    bgColorOn: String,
    bgColorOff: String,
    handleColorOn: String,
    handleColorOff: String,
    disabled: Boolean,
  },
  components: {
  },
  data: function () {
    return {
    }
  },
  computed: {
    switchClass: function () {
      if(this.state == 'off'){
        return '';
      }else if(this.state == 'pending'){
        return 'middle';
      }else if(this.state == 'on'){
        return 'on';
      }else{
        return '';
      }
    },
    ovalStyle: function () {
      var ovalStyle = '';
      if(this.state == 'on'){
        ovalStyle += 'border: 15px solid ' + this.bgColorOn + ';';
        ovalStyle += 'background-color: ' + this.bgColorOff + ';';
      }else if(this.state == 'off'){
        ovalStyle += 'border: 0 solid rgb(150,150,150);';
        ovalStyle += 'background-color: ' + this.bgColorOff + ';';
      }
      return ovalStyle;
    },
    circleStyle: function () {
      var circleStyle = '';
      if(this.state == 'on'){
        circleStyle = 'background-color: ' + this.handleColorOn + ';';
        circleStyle += 'left: 52px;';
      }else if(this.state == 'off'){
        circleStyle = 'background-color: ' + this.handleColorOff + ';';
      }
      return circleStyle;
    },
    disabledClass: function () {
      return this.disabled ? 'disabled' : '';
    },
  },
  methods: {
    switchClicked: function ($event) {
      if(!this.disabled){
        this.$emit('switchClicked', $event)
      }
    }
  },
}
</script>

<style>
  .SingleSwitchGeneral {
    width: 80px;
    height: 30px;
  }
  .SingleSwitchGeneral.disabled {
    opacity: 0.4;
  }
  .SingleSwitchGeneral-switchCircle {
    left: 2px;
    top: 2px;
    width: 26px;
    height: 26px;
    box-sizing: border-box;
    border-radius: 50%;
    /* box-shadow: 0 1px 3px rgba(0,0,0,0.4); */
    /* border: 1px solid rgb(150,150,150); */
    transition: all 0.2s linear;
  }
  .SingleSwitchGeneral-switchOval {
    border-radius: 50px;
    box-sizing: border-box;
    -webkit-transition: border 0.3s;
    -webkit-transition-timing-function: linear;
    transition: border 0.3s;
    transition-timing-function: linear;
  }
</style>
